import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _paq?: unknown[][];
  }
}

export function MatomoPageTracker() {
  const location = useLocation();
  const didTrackInitialPageView = useRef(false);

  useEffect(() => {
    if (!window._paq) return;

    if (!didTrackInitialPageView.current) {
      didTrackInitialPageView.current = true;
      return;
    }

    window._paq.push(['setCustomUrl', window.location.href]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
